import React, { useState } from "react";
import ArticleList from "../../components/Article";
import SuggestedFollows from "../../components/SuggestedFollow";
import NewsPortalList from "../../components/NewsPortals";
import Nav from 'react-bootstrap/Nav';

function News() {
  const [activeTab, setActiveTab] = useState("option1"); // Default tab
  return (
    <div className="right-panel-inner">
        <div className="post-section">

           <h2 className="mb-20">News</h2>
           
           {/* Navigation Tabs */}
            <Nav variant="pills" activeKey={activeTab} onSelect={(selectedKey) => setActiveTab(selectedKey)}>
              <Nav.Item>
                <Nav.Link eventKey="option1">Trending News</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="option2">Latest News</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="option3">News Portals</Nav.Link>
              </Nav.Item>
            </Nav>

            {/* Tab Content */}
            <div className="tab-content mt-3">
              {activeTab === "option1" && <div>
                <ArticleList trending="Trending" />
              </div>}
              {activeTab === "option2" && <div>
                <ArticleList />
              </div>}
              {activeTab === "option3" && <div>
                <NewsPortalList/>
              </div>}
            </div>
        </div>
        <div className="right-side-bar">
          <SuggestedFollows/>
        </div>
    </div>
  );
}

export default News;